/* eslint-disable quotes */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// eslint-disable-next-line no-undef
console.log(`Current UI Version is: ${UI_VERSION}`);

// eslint-disable-next-line react/jsx-filename-extension
ReactDOM.render(<App />, document.getElementById("ev-consent-app-root"));
